<script lang="ts">
	export let logoUrl: string | undefined;
	export let provider: string | undefined;
	export let layout: 'normal' | 'condensed' = 'normal';
	export let variant: 'light' | 'dark' = 'light';
</script>

<div
	class="provider-logo-wrapper"
	class:layout-condensed={layout === 'condensed'}
	class:layout-normal={layout === 'normal'}
	class:variant-light={variant === 'light'}
	class:variant-dark={variant === 'dark'}
>
	{#if logoUrl}
		<div class="provider-logo">
			<img src={logoUrl} alt={provider} />
		</div>
	{:else}
		<div class="provider-logo-placeholder">
			<i class="fas fa-building"></i>
		</div>
	{/if}
</div>

<style>
	.provider-logo-wrapper {
		flex-shrink: 0;
	}

	.provider-logo,
	.provider-logo-placeholder {
		flex-shrink: 0;
		width: 70px;
		height: 56px;
		border-radius: 8px;
		overflow: hidden;
		display: flex;
		align-items: center;
		justify-content: center;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	}

	.provider-logo-wrapper.layout-condensed .provider-logo,
	.provider-logo-wrapper.layout-condensed .provider-logo-placeholder {
		width: 32px !important;
		height: 22px !important;
		border-radius: 4px !important;
	}

	.provider-logo {
		background: rgba(255, 255, 255, 0.95);
		padding: 4px 8px;
	}

	.provider-logo-wrapper.layout-condensed .provider-logo {
		padding: 2px 4px !important;
	}

	.provider-logo img {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	.provider-logo-placeholder {
		background: rgba(255, 255, 255, 0.2);
		color: rgba(255, 255, 255, 0.8);
		font-size: 18px;
		backdrop-filter: blur(4px);
	}

	.provider-logo-wrapper.layout-condensed .provider-logo-placeholder {
		font-size: 12px !important;
	}

	.provider-logo-wrapper.variant-dark .provider-logo {
		background: rgba(255, 255, 255, 0.98);
		box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
	}

	.provider-logo-wrapper.variant-dark .provider-logo-placeholder {
		background: rgba(0, 0, 0, 0.08);
		color: var(--color-text-secondary, #666);
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
	}
</style>
